export default __webpack_public_path__ + "static/media/carbs.1c96dc7e.svg";